import React from "react";
import AboutUsImg from "../images/abot-us.png";
import intimateImg from "../images/intimate_white.svg";
import happyClientImg from "../images/happy_client_white.svg";
import AgentImg from "../images/agent-white.svg";
import experienceImg from "../images/experience_white.svg";
import viewOutput from "../images/view_output.png";
import partnerImg1 from "../images/partner_img_1.png";
import partnerImg2 from "../images/partner_img_2.png";
import partnerImg3 from "../images/partner_img_3.png";
import partnerImg4 from "../images/partner_img_4.png";
import { Link } from "react-router-dom";
import "../style/Slideshow.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import clientTwo from "../images/review/rev_2.jpg";
import clientThr from "../images/review/rev_3.jpg";
import clientFor from "../images/review/rev_4.jpg";
import clientfiv from "../images/review/rev_5.jpg";
import clientsix from "../images/review/rev_6.jpg";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { companyName } from "../Const";
import Features from "../components/features/Features";
import { REMDHome } from "../components/icons/IconSvg";

export default function AboutUs() {
    var slider_Clients = [
        {
            img: clientTwo,
            name: "Joan L.",
            ceo: "Seattle, WA",
            clientinfo: `Found my apartment in just two days with ${companyName}! Great filters and neighborhood info made it easy.`,
        },
        {
            img: clientThr,
            name: "Emma D.",
            ceo: "Chicago, IL",
            clientinfo: `I found the perfect rental in just one day using ${companyName}. The search filters actually work, and every listing was up to date!`,
        },
        {
            img: clientFor,
            name: "Jenna K.",
            ceo: "Houston, TX",
            clientinfo: "This is hands-down the easiest site to use for house hunting. No pop-ups, no fake listings — just real homes I could actually afford.",
        },
        {
            img: clientfiv,
            name: "Josh T.",
            ceo: "Denver, CO",
            clientinfo: `We relocated for work and needed a short-term rental fast. ${companyName} had more real options than anywhere else — and no scams.`,
        },
        {
            img: clientsix,
            name: "Sophia L.",
            ceo: "San Francisco, CA",
            clientinfo: "I found a rental that fit my needs quickly and easily. The listings were trustworthy and the process was hassle-free.",
        },
    ];
    return (
        <>
            <div className="new-build-sec">
                <div className="container">
                    <div className="new-build-container">
                        <div className="new-build-left">
                            <img src={AboutUsImg} alt="Better lives with better homes" />
                        </div>
                        <div className="new-build-right">
                            <div className="our-build">
                                 <REMDHome />
                                <p>Trusted {companyName}</p>
                            </div>
                            <div className="living-space-sec our-build-space">
                                <h1>Better lives with better homes</h1>
                                <p>At {companyName}, we believe that every property tells a story — of ambition, lifestyle, and growth. With a strong focus on off-plan and secondary properties, we guide our clients through Dubai’s vibrant real estate market, offering opportunities that match both aspirations and investments.</p>
                                <p>Backed by over 20 years of experience, our property specialists bring a wealth of knowledge and insight to every transaction. What sets us apart is our commitment to transparency, professionalism, and personalized service. From the very first consultation to the final handover, we ensure every step is seamless, informed, and rewarding.</p>
                            </div>
                            <div className="about-btn">
                                <Link to="/property/for-sale" className="button">
                                    Explore Properties
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="our-partner-sec">
                <div className="container">
                    <div className="new-build-container">
                        <div className="our-partner-left our-build-space">
                            <h2>We are your partner in creating a legacy building facade.</h2>
                            <p>Real estate, to us, is not just about transactions — it’s about shaping futures and creating lasting relationships. We are dedicated to building trust, delivering long-term value, and helping our clients find not just properties, but places they can truly call home. At {companyName}, your journey in Dubai starts with confidence and ends with success.</p>
                            <div className="about-btn">
                                <Link to="/property/for-sale" className="button">
                                    Find Properties
                                </Link>
                            </div>
                        </div>
                        <div className="partner-build-right">
                            <img src={partnerImg1} alt="partnerImg1" />
                            <img src={partnerImg2} alt="partnerImg2" />
                            <img src={partnerImg4} alt="partnerImg4" />
                            <img src={partnerImg3} alt="partnerImg3" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="why-choose-sec">
                <div className="container">

                <div className="our-build-space">
                    <h2>Why Choose Us ?</h2>
                    <p>Here’s just a few reasons why homeowners are choosing realty to sell their property.</p>
                </div>
                <div className="choose-info-cards">
                    <div className="c4-wrap">
                        <div className="c4">
                            <div className="badge-4">
                                <img src={experienceImg} alt="Extensive Expertise" />
                            </div>
                            <h3 className="choose-info-title">Extensive Expertise</h3>
                            <div className="choose-info-underline" style={{ background: "#f15a24" }}></div>
                            <p className="choose-info-text">With over 20 years of experience, our property specialists bring unmatched knowledge of Dubai’s real estate market to help you make informed decisions.</p>
                        </div>
                    </div>
                    <div className="c4-wrap">
                        <div className="c4">
                            <div className="badge-4">
                                <img src={happyClientImg} alt="Personalized Guidance" />
                            </div>
                            <h3 className="choose-info-title">Personalized Guidance</h3>
                            <div className="choose-info-underline" style={{ background: "#f15a24" }}></div>
                            <p className="choose-info-text">We provide tailored solutions for every client, ensuring your property journey — whether off-plan or secondary — is smooth and hassle-free.</p>
                        </div>
                    </div>
                    <div className="c4-wrap">
                        <div className="c4">
                            <div className="badge-4">
                                <img src={AgentImg} alt="Trusted & Transparent" />
                            </div>
                            <h3 className="choose-info-title">Trusted & Transparent</h3>
                            <div className="choose-info-underline" style={{ background: "#f15a24" }}></div>
                            <p className="choose-info-text">Our commitment to honesty, transparency, and professionalism ensures you can invest with confidence and peace of mind.</p>
                        </div>
                    </div>
                    <div className="c4-wrap">
                        <div className="c4">
                            <div className="badge-4">
                                <img src={intimateImg} alt="Long-Term Value" />
                            </div>
                            <h3 className="choose-info-title">Long-Term Value</h3>
                            <div className="choose-info-underline" style={{ background: "#f15a24" }}></div>
                            <p className="choose-info-text">We focus on building lasting relationships and delivering properties that create real value for your future.</p>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="client-feedback-sec">
                <div className="container">
                    <div className="client-feedback-inner">
                        <div className="our-build">
                            <REMDHome />
                            <p>Trusted {companyName}</p>
                        </div>
                        <div className="our-build-space">
                            <h2>Our Client’s Feedback</h2>
                        </div>
                    </div>
                    <div className="client-slider">
                        <Swiper
                            modules={[Navigation, Pagination]}
                            slidesPerView={1}
                            spaceBetween={20}
                            navigation={{
                                nextEl: ".next",
                                prevEl: ".prev",
                            }}
                            pagination={{ clickable: true, el: ".client-pagination" }}
                            loop={false}
                            breakpoints={{
                                1024: { slidesPerView: 2 },
                                575: { slidesPerView: 1 },
                            }}
                        >
                            {slider_Clients.map((slide, index) => (
                                <SwiperSlide key={index}>
                                    <div className="client-slider-inner">
                                        <div className="client-slider-details">
                                            <div className="client-slider-left">
                                                <div>
                                                    <img src={slide.img} alt={slide.name} />
                                                </div>
                                                <div className="client-slider-left-inner">
                                                    <h3>{slide.name}</h3>
                                                    <span>{slide.ceo}</span>
                                                </div>
                                            </div>
                                            <div className="output-img">
                                                <img src={viewOutput} alt={`${slide.name}_${index}`} />
                                            </div>
                                        </div>
                                        <div className="client-info">
                                            <p>{slide.clientinfo}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <button className="prev" aria-label="Previous Slide">
                            ❮
                        </button>
                        <button className="next" aria-label="Next Slide">
                            ❯
                        </button>
                        <div className="client-pagination"></div>
                    </div>
                </div>
            </div>

            <Features />
        </>
    );
}
